import React from 'react';
import PropTypes from 'prop-types';

const IconGoodCondition = ({ width = 29, height = 28, fill = '#696969' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 29 28'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12.6816 16L8.68164 12L6.68164 14L12.6816 20L22.6816 10L20.6816 8L12.6816 16ZM14.6816 0C6.94964 0 0.681641 6.268 0.681641 14C0.681641 21.732 6.94964 28 14.6816 28C22.4136 28 28.6816 21.732 28.6816 14C28.6816 10.287 27.2066 6.72601 24.5811 4.1005C21.9556 1.475 18.3947 0 14.6816 0ZM14.6816 26C8.05464 26 2.68164 20.627 2.68164 14C2.68164 7.373 8.05464 2 14.6816 2C21.3086 2 26.6816 7.373 26.6816 14C26.6816 17.1826 25.4174 20.2348 23.1669 22.4853C20.9165 24.7357 17.8642 26 14.6816 26Z'
                fill={fill}
            />
        </svg>
    );
};

IconGoodCondition.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    fill: PropTypes.string,
};

export default React.memo(IconGoodCondition);
